import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  dataVerificationDetails: null || [],
  dataVerificationProject: null || [],
  dataVerificationProjectDownload: null || [],
  error: null,
  totalCount: 0,
};

const dataVerificationSlice = createSlice({
  name: "dataVerification",
  initialState,
  reducers: {
    fetchDataVerificationStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    fetchDataVerificationSuccess(state, action) {
      state.isLoading = false;
      state.dataVerificationDetails = action.payload;
      state.totalCount = action.payload.totalCount;
      state.error = null;
    },
    fetchDataVerificationFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    fetchDataVerificationProjectStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    fetchDataVerificationProjectSuccess(state, action) {
      state.isLoading = false;
      state.dataVerificationProject = action.payload;
      state.error = null;
    },
    fetchDataVerificationProjectFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    fetchVerificationDownloadStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    fetchVerificationDownloadSuccess(state, action) {
      state.isLoading = false;
      state.dataVerificationProjectDownload = action.payload;
      state.error = null;
    },
    fetchVerificationDownloadFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchDataVerificationStart,
  fetchDataVerificationSuccess,
  fetchDataVerificationFailure,
  fetchDataVerificationProjectStart,
  fetchDataVerificationProjectSuccess,
  fetchDataVerificationProjectFailure,
  fetchVerificationDownloadStart,
  fetchVerificationDownloadSuccess,
  fetchVerificationDownloadFailure,
} = dataVerificationSlice.actions;

export default dataVerificationSlice.reducer;
